import { Component, OnInit, Input } from '@angular/core';
import { trigger, style, transition, animate } from '@angular/animations';

@Component({
  selector: 'cart-display',
  template: `
    <div class="cart-wrapper" [@valueAnimation]="credits">
      <img src="./assets/images/evatoken_white.svg" class="eva-token" />
      <span class="credits-display">{{ credits }}</span>
    </div>
  `,
  styles: [
    `
      .cart-wrapper {
        color: white;
        display: inline-block;
        width: 60px;
      }
      .eva-token {
        width: 20px;
        height: 20px;
        position: absolute;
        margin-top: 8px;
      }
      .credits-display {
        position: relative;
        background-color: var(--header-darken-5);
        border-radius: 15px;
        padding: 3px 8px 3px 8px;
        margin-left: 10px;
      }
    `
  ],
  animations: [
    trigger('valueAnimation', [
      transition(':increment', [style({ transform: 'scale(1.1)' }), animate('200ms ease-in-out')]),
      transition(':decrement', [style({ transform: 'scale(1.1)' }), animate('200ms ease-in-out')])
    ])
  ]
})
export class CartDisplayComponent implements OnInit {
  @Input() credits: number;

  constructor() {}

  ngOnInit() {}
}



// WEBPACK FOOTER //
// ./src/app/modules/shared/cart-display.component.ts